import styled from "styled-components"
import { TextButton } from "../Text"
import ExpandedMenuDesktop from "./ExpandedMenuDesktop"
import { useRecoilState } from "recoil"
import { isMenuExpandedState } from "../../../recoil/common/Header"

const MenuDesktop = () => {
  const [isMenuExpanded, setIsMenuExpanded] =
    useRecoilState(isMenuExpandedState)

  return (
    <MenuContainer onMouseOver={() => setIsMenuExpanded(true)}>
      <MenuDiv>
        <MenuButton>소개</MenuButton>
      </MenuDiv>
      <MenuDiv>
        <MenuButton>학문 적성 검사</MenuButton>
      </MenuDiv>
      <MenuDiv>
        <MenuButton>문의</MenuButton>
      </MenuDiv>
      {isMenuExpanded && <ExpandedMenuDesktop />}
    </MenuContainer>
  )
}

export default MenuDesktop

const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 60px;
`

const MenuDiv = styled.div`
  width: 200px;
`

const MenuButton = styled(TextButton).attrs(() => ({
  color: "var(--custom-deep-dark-brown)",
  fontSize: 20,
}))`
  &:hover {
    color: var(--custom-blue);
  }
`
